// will help tooltip to not get smushed
var popoverOverflowModifiers = {
  preventOverflow: {
    enabled: false
  },
  hide: {
    enabled: false
  },
  flip: {
    boundariesElement: "viewport"
  }
};
export default popoverOverflowModifiers;